import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import {
  calculateAngularGradientPosition,
  calculateGradientColorStops,
} from "../../../utils/colors.ts";

export function createAngularGradient(
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  paint: FigmaRestApi.GradientPaint,
): string {
  const { gradientHandlePositions, gradientStops } = paint;
  let value = "conic-gradient(";

  value += calculateAngularGradientPosition(gradientHandlePositions);

  value += calculateGradientColorStops(stylesFormatsConfig, gradientStops);

  value += ")";

  return value;
}
